import { Check, ChevronsUpDown, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useHousehold } from "@/context/HouseholdContext";
import { t } from "@/i18n";

export const HouseholdSwitcher = () => {
  const { households, active, select } = useHousehold();
  const navigate = useNavigate();
  if (!households.length) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="flex min-w-0 items-center gap-2 rounded-full border border-border bg-card px-3 py-1.5 text-sm font-medium transition-colors hover:bg-secondary"
        data-testid="household-switcher-button"
      >
        <Home className="h-4 w-4 shrink-0 text-sage" />
        <span className="max-w-[9rem] truncate sm:max-w-[14rem]">{active?.name}</span>
        <ChevronsUpDown className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel className="eyebrow">Mes foyers</DropdownMenuLabel>
        {households.map((h) => (
          <DropdownMenuItem key={h.id} onClick={() => select(h.id)} data-testid={`household-option-${h.id}`} className="flex items-center gap-2">
            <div className="min-w-0 flex-1">
              <div className="truncate">{h.name}</div>
              <div className="text-xs text-muted-foreground">{t(`roles.${h.role}`)}</div>
            </div>
            {active?.id === h.id && <Check className="h-4 w-4 text-sage" />}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/foyer")} data-testid="household-manage-link">Gérer mes foyers</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
